import React from "react";
import {
    USER_STATE,
    DEFAULT_DEBOUNCE_TIMEOUT,
    DEFAULT_PAGE,
    DEFAULT_MEDIUM_FETCHED_OPTIONS,
} from "consts";
import { getUsers } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const UserAutoSuggest = (props) => (
    <AutoSuggest
        label="User"
        fetchOptions={(q) => props.onDataFetch(q)}
        renderOption={(user) => ({
            label: `${user.FullName} - ${user.Name} ${user.State === USER_STATE.INACTIVE ? '(inactive)' : ''}`,
            value: user,
        })}
        optionIdentifier={(user) => user.Name}
        debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
        {...props}
    />
);

UserAutoSuggest.defaultProps = {
    onDataFetch: (q) =>
        getUsers(q, DEFAULT_PAGE, DEFAULT_MEDIUM_FETCHED_OPTIONS, null, null, true)
            .then(value => value.content)
};

export default UserAutoSuggest;
